import React from 'react';
import { StyleSheet, View } from 'react-native';
import Amount from 'design-system/Amount';
import Text from 'design-system/Text';
import BlurAmountView from 'design-system/BlurAmountView';
import { formatAmount } from 'utils/formatting';
import BudgetingCircleChart from 'features/feed/components/analytics/BudgetingCircleChart';
import { rem } from 'design-system/values';
import { getFontSize } from '../utils';
export const BudgetingCircleProgressBar = ({ committed, currency, spending, totalBudget, hasCircle, scrambled, gradientColors, baseLimit, rollingAmount, }) => {
    const committedBudgetRatio = hasCircle && committed ? (committed + spending) / totalBudget : null;
    const spentBudgetRatio = (spending > 0 ? 0 : -spending) / totalBudget;
    const leftOfBudget = spending > 0 ? totalBudget : totalBudget + spending;
    const resultantBudget = (baseLimit || 0) + (rollingAmount || 0) + spending;
    return (<View style={styles.graphContainer}>
        <View style={styles.graphText}>
          {rollingAmount && totalBudget < 0 ? (<>
              <Amount {...getFontSize(resultantBudget)} value={{
                value: resultantBudget,
                currency,
            }} showFraction centered numbersBold numberOfLines={1}/>
              <Text TextThin-14 centered Gray adjustsFontSizeToFit>
                {(baseLimit || 0) + (rollingAmount || 0) === 0
                ? ''
                : 'will roll over'}
              </Text>
            </>) : (<>
              <Amount {...getFontSize(Math.abs(leftOfBudget))} value={{
                value: Math.abs(leftOfBudget),
                currency,
            }} showFraction centered numberOfLines={1} numbersBold style={leftOfBudget < 0 && styles.chartTextExtraMargin}/>
              <BlurAmountView enabled={scrambled}>
                <Text TextThin-14 centered Gray adjustsFontSizeToFit>
                  {leftOfBudget >= 0 ? 'left of' : 'over your budget\nof'}{' '}
                  <Text NumbersThin-14 centered Gray>
                    {formatAmount(totalBudget, currency, 2)}
                  </Text>
                </Text>
              </BlurAmountView>
            </>)}
        </View>
        <BudgetingCircleChart large isEmpty={!!rollingAmount && totalBudget <= 0} gradientColors={gradientColors} committedRatio={committedBudgetRatio} spentRatio={spentBudgetRatio}/>
      </View>);
};
const styles = StyleSheet.create({
    graphContainer: {
        justifyContent: 'center',
        alignSelf: 'center',
        paddingVertical: rem(16),
    },
    graphText: {
        position: 'absolute',
        alignSelf: 'center',
        justifyContent: 'center',
        maxWidth: rem(140),
    },
    chartTextExtraMargin: {
        marginTop: rem(8),
    },
});
